import { Typography } from '@mui/material';

export const BoxTitle: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return (
        <Typography sx={{ padding: '15px', fontWeight: 'bold' }} variant="h4">
            {children}
        </Typography>
    );
};
